import { SendInvestorInviteDto } from '@dealstack/shared/lib/generated';
import { postMipInvestorsInvitations } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';
import { useWrappedRequest } from '@dealstack/frontend/shared/other/react/ApiWrapper';
import { isStandardBackendError } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useWorkflowProgress } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/WorkflowProgress/WorkflowProgressContext';
import {
	useTranslationDefault,
	useTranslationMipManage,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const useSendInvestorInvitations = () => {
	const postMIPInvestorsInvitationsRequest = useWrappedRequest(postMipInvestorsInvitations);
	const tDefault = useTranslationDefault();
	const tMipManage = useTranslationMipManage();
	const { startEmailWorkflow } = useWorkflowProgress();

	const sendInvitations = async (invites: SendInvestorInviteDto): Promise<void> => {
		await postMIPInvestorsInvitationsRequest
			.fetch(invites)
			.onSuccess((response) => {
				startEmailWorkflow(response.payload?.investorInviteWorkflowHandle);
			})
			.onLocalError((responseError) => {
				const errorMessage = isStandardBackendError(responseError)
					? tDefault(`error_codes.${responseError.error?.code}`)
					: tMipManage('send_modal.toast.error.message');
				showToastV2({
					title: errorMessage,
					state: 'error',
				});
				throw responseError;
			})
			.concludeWithPromise();
	};

	return {
		sendInvitations,
		isSending: postMIPInvestorsInvitationsRequest.isLoading,
	};
};
